export class Utilities {

    static get_current_url_params(){
        const uRLSearchParams = new URLSearchParams(window.location.search);
        let params = {};
        for (const [key, value] of uRLSearchParams.entries()) {
            if (params[key]) {
                // If the parameter exists, convert it to an array if not already, and push the new value
                if (Array.isArray(params[key])) {
                    params[key].push(value);
                } else {
                    params[key] = [params[key], value];
                }
            } else {
                params[key] = value;
            }
        }
        return params;
    }

    static array_to_url_params(key, array){
        if(array.length > 1){
            return array.reduce((prev,next) => {return `${key}=${prev}&${key}=${next}&`});
        }
        return `${key}=${array[0]}&`;
    }

    static filter_properties (obj, keysToKeep) {
        return Object.fromEntries(
          Object.entries(obj).filter(([key]) => keysToKeep.includes(key))
        );
    }

    static async ensureCookieAccess() {
        if (document.hasStorageAccess) {
            const hasAccess = await document.hasStorageAccess();
            if (!hasAccess) {
                try {
                    await document.requestStorageAccess();
                    return true; // accès accordé
                } catch (err) {
                    console.warn("Accès refusé:", err);
                    return false;
                }
            }
            return true; // déjà accordé
        } else {
            // API non supportée → on suppose que les cookies passent
            console.info("Storage Access API non supportée, cookies probablement accessibles");
            return true;
        }
    }
}